import React, { Component } from 'react'
import './components/Admin/styles/AdminMain.css'
import { BrowserRouter as Router, Route, Link } from "react-router-dom";
import firebase from './firebase'

import KindredLogo from './assets/kp png logo.svg';

import ServicesEdit from './components/Admin/ServicesEdit'
import TeamEdit from './components/Admin/TeamEdit'
import PortfolioEdit from './components/Admin/PortfolioEdit'
import CompanyInfoEdit from './components/Admin/CompanyInfoEdit'
import LoginScreen from './components/Admin/LoginScreen'

const SCREEN_PORTFOLIO = 0;
const SCREEN_TEAM = 1;
const SCREEN_SERVICES = 2;
const SCREEN_LOGIN = 3;
const SCREEN_INFO = 4;

export default class AdminSide extends Component {

	state = {
		isDeciding: true,
		authenticated: false,
		currentScreen: SCREEN_LOGIN,
		loginErrorMsg: null
	}
	
	componentDidMount() {

		document.title = "Kindred Productions - Admin Panel";

		firebase.auth().onAuthStateChanged((user) => {

			if (user) {
				// User is signed in.
				let url = window.location.href;

				if (url.includes('portfolio')) {
					this.setState({
						currentScreen: SCREEN_PORTFOLIO
					});
				} else if (url.includes('services')) {
					this.setState({
						currentScreen: SCREEN_SERVICES
					});

				} else if (url.includes('team')) {
					this.setState({
						currentScreen: SCREEN_TEAM
					});
				} else if (url.includes('info')) {
					this.setState({
						currentScreen: SCREEN_INFO
					});
				} else {
					this.setState({
						currentScreen: SCREEN_PORTFOLIO
					});
				}

				this.setState({
					authenticated: true,
				})

			} else {
				this.setState({
					authenticated: false
				})
			}

			this.setState({
				isDeciding: false
			})
		});

	}

	switchSelected = (screen) => {
		this.setState({
			currentScreen: screen
		});
	}

	signIn = (email, password) => {

		this.setState({
			loginErrorMsg: null
		})
		
		firebase.auth().signInWithEmailAndPassword(email, password).catch((error) => {
			if (error) {
				// Handle Errors here.
				//var errorCode = error.code;
				//var errorMessage = error.message;

				this.setState({
					loginErrorMsg: 'Invalid Credentials'
				})

			} else {
				this.setState({
					authenticated: true,
					currentScreen: SCREEN_PORTFOLIO
				})
			}

			this.setState({
				isDeciding: false
			})

			// ...
		});
	}

	signOut = () => {
		firebase.auth().signOut().then(function () {
			this.setState({
				authenticated: false
			})
		}).catch(function (error) {
			// An error happened.
		});
	}

  render() {

		if (this.state.isDeciding) {
			return (<div/>);
		}

		if (this.state.authenticated) {
			let portfolioSelected = null;
			let teamSelected = null;
			let servicesSelected = null;
			let infoSelected = null;

			switch (this.state.currentScreen) {
				case SCREEN_PORTFOLIO:
					portfolioSelected = 'selected';
					break;
				case SCREEN_TEAM:
					teamSelected = 'selected';
					break;
				case SCREEN_SERVICES:
					servicesSelected = 'selected';
					break;
				case SCREEN_INFO:
					 infoSelected = 'selected';
					break;
			}

			return (

				<Router>
					<div className="admin-container">
						<div className="sidebar">
							<div className="upper-part">
								<img src={KindredLogo} />
							</div>

							<div className="lower-part">
								<Link to="/admin/portfolio/">
									<div className={`menu-item ${portfolioSelected}`} onClick={this.switchSelected.bind(this, SCREEN_PORTFOLIO)}>
										Portfolio
								</div>
								</Link>

								<Link to="/admin/team/">
									<div className={`menu-item ${teamSelected}`} onClick={this.switchSelected.bind(this, SCREEN_TEAM)}>
										Team
								</div>
								</Link>

								<Link to="/admin/services/">
									<div className={`menu-item ${servicesSelected}`} onClick={this.switchSelected.bind(this, SCREEN_SERVICES)}>
										Services
								</div>
								</Link>

								<Link to="/admin/info/">
									<div className={`menu-item ${infoSelected}`} onClick={this.switchSelected.bind(this, SCREEN_INFO)}>
										Company Info
								</div>
								</Link>

								<div className="menu-item" onClick={this.signOut}>
									Logout
								</div>

							</div>
						</div>

						<div className="admin-main-content">
							<div className="admin-wrapper">
								<Route path="/admin/" exact component={PortfolioEdit} />
								<Route path="/admin/services/" exact component={ServicesEdit} />
								<Route path="/admin/portfolio/" exact component={PortfolioEdit} />
								<Route path="/admin/team/" exact component={TeamEdit} />
								<Route path="/admin/info/" exact component={CompanyInfoEdit} />
							</div>
						</div>
					</div>
				</Router>
			)
		} else { // view login screen
			return (
				<LoginScreen loginAction = {this.signIn} errorMsg={this.state.loginErrorMsg} />
			);
		}

		
  }
}
